import { useDispatch } from 'react-redux';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UILink from 'UIComponents/link/UILink';
import { reloadThreadsData } from '../actions/reloadThreadsData';
import { jsx as _jsx } from "react/jsx-runtime";
const ConnectedRefreshLink = () => {
  const dispatch = useDispatch();
  return /*#__PURE__*/_jsx(UILink, {
    onClick: () => {
      dispatch(reloadThreadsData());
    },
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "ConversationsInboxUI.threadBatchOperations.alert.refreshLink"
    })
  });
};
ConnectedRefreshLink.displayName = 'RefreshLink';
export default ConnectedRefreshLink;